<template>
    <div class="splash-header flex flex-col justify-end text-left gap-10 pt-4 mb-2 pl-3">
        <div>
            <p class="text-valence-grey-750 title-subsection">{{ dateDisplay }}</p>
            <h3 class="display-medium text-balance fs-mask">{{ greetMessageWithUser }}!</h3>
        </div>
    </div>
</template>

<script setup>
import { convertToDateTime, humanizedTimeOfDay } from "/js/dateUtils";
import { DateTime } from "luxon";
import { computed } from "vue";

const { name, coachingSessionCreatedAt } = defineProps({
    name: { type: String, default: "" },
    coachingSessionCreatedAt: { type: String, default: null },
});
const dateDisplay = computed(() => {
    const date = coachingSessionCreatedAt ? convertToDateTime(coachingSessionCreatedAt) : DateTime.now();
    return date.toFormat("LLL dd, yyyy");
});
const currentTimeOfDay = humanizedTimeOfDay();
const greetMessageWithUser = computed(() => `Good ${currentTimeOfDay}${name ? `, ${name}` : ""}`);
</script>

<style scoped>
@reference "../../../css/tailwind.css";

/* The prototype starts the thread at Nadia's first message, so the date and
   greeting header only render on the legacy theme. */
html[data-theme="tonal"] .splash-header {
    display: none;
}
</style>
